import React from 'react';
import { Helmet } from 'react-helmet-async';
import { 
  Box, 
  Typography, 
  Container,
  alpha,
  useTheme,
} from '@mui/material';
import CurrencyConverter from '../components/CurrencyConverter';

const ConverterPage = () => {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Currency Converter - RatePly</title>
        <meta name="description" content="Convert currencies with real-time exchange rates. Fast, accurate, and free currency conversion tool." />
      </Helmet>
      
      <Container maxWidth="md" sx={{ py: 4 }}>
        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: 'white',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
              mb: 2,
            }}
          >
            Currency Converter
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: alpha(theme.palette.common.white, 0.9),
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            Convert between 170+ currencies with real-time exchange rates.
            Get accurate conversions for travel, business, or personal use.
          </Typography>
        </Box>

        {/* Converter Component */}
        <CurrencyConverter showTitle={false} />

        {/* Additional Info */}
        <Box
          sx={{
            mt: 6,
            p: 4,
            borderRadius: 3,
            background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.1)} 0%, ${alpha(theme.palette.background.default, 0.1)} 100%)`,
            backdropFilter: 'blur(10px)',
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{ color: 'white', fontWeight: 600, mb: 3 }}
          >
            Real-Time Exchange Rates
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: alpha(theme.palette.common.white, 0.8),
              mb: 2,
              lineHeight: 1.6,
            }}
          >
            Our currency converter uses live exchange rates from trusted financial data providers.
            Rates are updated every hour to ensure you get the most accurate conversions possible.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: alpha(theme.palette.common.white, 0.7),
              fontStyle: 'italic',
            }}
          >
            Perfect for travelers, businesses, and anyone dealing with international currencies.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default ConverterPage;
